export enum UserKind {
  FREE = "FREE",
  PAID = "PAID",
  ADMIN = "ADMIN",
}
